import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const activateMarketingSubscription = () => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.POST,
    path: `/api/v1/profiles/marketing_subscribes`,
  });
};

export default activateMarketingSubscription;
